import React from "react";
import { useApp } from "../../contexts/AppContext";
import { formatDateTime } from "../../utils/localization";
import { t } from "../../utils/localization";
import styles from "./Header.module.css";

export default function Header() {
  const { state } = useApp();
  const now = new Date();
  const dateTime = formatDateTime(now);

  return (
    <header className={styles.headerContainer}>
      <div className={styles.logo}>
        <div className={styles.logoImage}>
          <img
            src={
              state.language === "en"
                ? "/images/logo_en.svg"
                : "/images/logo_ru.svg"
            }
            alt="logo"
          />
        </div>
      </div>

      <div className={styles.dateTime}>
        <span className={styles.time}>{dateTime.time}</span>
        <span className={styles.date}>{dateTime.date}</span>
      </div>
    </header>
  );
}
